<card-wrapper>
  <svg-icon-sprite src="./assets/img/icons/sprite.svg#hint"></svg-icon-sprite>
  <h1 translate="profile-identity.status.banned"></h1>
  <p>{{ ('profile-identity.label.reason' | translate) + '&nbsp;' + ((banReason$ | async) || '') }}</p>
  <btn
    buttonText="common.btn.go-to-dashboard"
    routerLink="/dashboard"
  ></btn>
</card-wrapper>
